module.exports = __webpack_public_path__ + "static/media/instructor-3.7e99913a.png";